import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { SEND_REQUEST } from '../../Actions/User'

class AddFriendButton extends Component {

    state = {
        sent: false
    }

    handleAddFriend = (id) => {
        this.props.actions.SEND_REQUEST(id)
        this.setState({
            sent: true
        })
    }

    render() {
        const { friendId } = this.props;
        const { sent } = this.state

        let button = (
            <button className="c-btn c-btn--alt c-btn--primary c-list-btn" onClick={ () => this.handleAddFriend(friendId) }>Toevoegen</button>
        )

        if(sent) {
            button = (
                <button className="c-btn c-btn--alt c-btn--primary c-list-btn c-btn--disabled">Toegevoegd</button>
            ) 
        }

        return (
            <>
                {button}               
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({SEND_REQUEST}, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddFriendButton)